import { ROUTES } from '@/navigation/constants'

export const LEARN_TOPIC_TABS = [
    { key: 'all', labelEs: 'Todos', labelEn: 'All', to: ROUTES.learn },
    { key: 'esc', labelEs: 'Escandallos', labelEn: 'Recipe costing', to: ROUTES.learnEscandallos },
    { key: 'ben', labelEs: 'Beneficio', labelEn: 'Profit', to: ROUTES.learnBeneficio },
    { key: 'inv', labelEs: 'Inventario', labelEn: 'Inventory', to: ROUTES.learnInventario },
    {
        key: 'emprender',
        labelEs: 'Emprender en hostelería',
        labelEn: 'Starting in hospitality',
        to: ROUTES.learnEmprenderEnHosteleria,
    },
] as const

export type LearnTopicTabKey = (typeof LEARN_TOPIC_TABS)[number]['key']
